import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FormCountrySelector from 'components/FormCountrySelector/FormCountrySelector';
import { DEFAULT_LANGUAGE } from 'constants/language';
import trimAllSpaces from 'utils/text/trimAllSpaces';
import InputRegistrationNumber from './InputRegistrationNumber';
import InputsInternationalVehicle from './InputsInternationalVehicle';
export default function VehicleForm({
  vehicleFormId
}) {
  const {
    t
  } = useTranslation();
  const {
    control,
    watch
  } = useFormContext();
  const selectedCountry = watch('nationality');
  const defaultRegistrationNumber = trimAllSpaces(control.defaultValuesRef.current.registrationNumber);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormCountrySelector, {
    control: control,
    name: "nationality",
    label: t('vehicles.nationality')
  }), selectedCountry === DEFAULT_LANGUAGE ? /*#__PURE__*/React.createElement(InputRegistrationNumber, {
    defaultValue: defaultRegistrationNumber,
    vehicleFormId: vehicleFormId
  }) : /*#__PURE__*/React.createElement(InputsInternationalVehicle, {
    vehicleFormId: vehicleFormId
  }));
}